/**
 * Application Configuration
 *
 * Environment variables:
 * - REACT_APP_API_BASE_URL: Base URL for the backend API
 *
 * Usage:
 * import { API_BASE_URL } from './config';
 * apiClient.get('/strava/authorize')
 *
 * Build: 2026-01-04 - JWT authentication enabled
 */

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:5000/api';

// For debugging - always log in console to help troubleshoot
console.log('API Configuration:', {
  API_BASE_URL,
  env: process.env.NODE_ENV,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL
});
// Railway deployment - JWT auth enabled 2026-01-04
